var AdaptiveImage = require( "../../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/ic_discount.dcfbb0b4.png","uri@2x": __webpack_public_path__ + "static/media/ic_discount.07dc62d8.png","uri@3x": __webpack_public_path__ + "static/media/ic_discount.694f9806.png",
    width: 12,
    height: 12
});